import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col } from "react-bootstrap";
import { Modal as ModalReactstrap } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";

/* IMPORT UTILS */
import { emptyImage, getCloudImageUrl, convertToRupiah } from "../../../utils";
import { printErrorNew, printError } from "../../../utils/Helpers";
import { isNumeric } from "../../../helpers/regex";
import { useOtpStorage } from "../../../helpers/dom";
import Analytics from "../../../services/Analytics";

/* ACTIONS */
import { getShoppingCartList } from "../../../actions/shoppingCartAction";
import { getHistoryShipping } from "../../../actions/postalCodeAction";
import { getUserVoucher } from "../../../actions/kickPointAction";
import { doPostUserOffer, updateOffer, resetPostUserOffer } from "../../../actions/offerAction";

import {
  doPostPayments,
  doPostApplyVoucher,
  doPostXenditPayment,
  doPostKredivoPayment,
  doPostMidtransPayment,
  doPostAkulakuPayment,
  doGetVoucherCode,
  doFetchProductAddon,
  doPostAtomePayment,
  doPostKredivoAvailableInstallments,
} from "../../../actions/paymentAction";

import {
  doFetchCountries,
  doFetchProvinces,
  doFetchCities,
  doPostShippingCost,
} from "../../../actions/postalCodeAction";

import {
  getOtp,
  resetOtpState,
  getOtpStatus
} from "../../../actions/authAction";

/* COMPONENTS */
import {
  ModalOutOfStock,
  ModalAlert,
  ModalAddressBookV3,
  ModalOtp
} from "../../Modals";
import ChoosePaymentProcess from "./ChoosePaymentProcess"
import ChoosePaymentProcessResponsive from "./ChoosePaymentProcessResponsive"
import KickCreditProcess from "./KickCreditConfirmationProcess"
import OtherPaymentsConfirmationProcess from "./OtherPaymentsConfirmationProcess"
import PopUpErrorMessage from "./PopUpErrorMessage"

/* IMPORT PAYMENT METHOD */
import {
  BANKTRANSFER,
  VIRTUALACCOUNT,
  CREDITCARD,
  KREDIVO,
  AKULAKU,
  getAdmFees,
  FULLWALLET,
  BCA_VA,
  BRI_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA,
  BCA_INSTALLMENTS,
  BCA_CREDIT_CARD,
  DEFAULT_CREDIT_CARD,
  MANDIRI_CREDIT_CARD,
  GOPAY,
  ATOME,
  DEFAULT_PAYMENT_METHOD
} from "../../../constants/paymentMethods";

/* ASSETS */
import PinAddress from "../../../images/pin-address.png";
import BackArrow from "../../../images/shopping-cart-back.png";
import ContinueArrow from "../../../images/shopping-cart-continue.png";
import CircleBack from "../../../images/circle-back.png";
import KickAveLogoGif from "../../../images/logokickave_loop.gif";


const ButtonBuy = styled.button`
  text-decoration: underline;
  color: #4990e2;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

const LoadingSubmit = ({ show }) => {
  return (
    <ModalReactstrap id="loading-submit-payment-container" isOpen={show}>
      <div className="loading-submit-payment-inner-wrapper">
        <div className="logo-container">
          <KickImage src={KickAveLogoGif} alt="..." />
        </div>
        <div className="text-container">
          <p>Hold On Tight</p>
          <p>We are processing your payment</p>
        </div>
      </div>
    </ModalReactstrap>
  )
}

function MakeOfferPage(props) {
  const {
    dataProductInProgress,
    productAddon,
    doFetchProductAddon,
    getHistoryShipping,
    dataPostalCode,
    getCountries,
    getCities,
    dataCountries,
    getProvinces,
    dataProvinces,
    dataAuth,
    dataPayments,
    dataCart,
    getShippingFee,
    getUserVoucher,
    dataVoucher,
    dataAkulaku,
    doGetKredivoInstallments,
    selectedSize,
    submitXenditPayment,
    submitMidtransPayment,
    submitKredivoPayment,
    submitAkulakuPayment,
    submitAtomePayment,
    submitPayment,
    dataProductDetails,
    doPostUserOffer,
    resetPostUserOffer,
    dataOffer = {},
    history,
    match,
    offerPending,
    updateOffer,
    collection_id,
    getOtp,
    otpCode,
    resetOtpState,
    userData,
    otpStatus,
    getOtpStatus
  } = props;

  const { shippingHistory = {}, provinces, countries, cities, couriers } =
    dataPostalCode || {};

  const {
    dataInprogress,
    isFromDetail,
    allParentProps,
  } = dataProductInProgress;

  const {
    category,
    sell = {},
    size = {},
    productCondition,
    etaText,
    asking_price,
    highestOffer = "",
    inputOffer
  } = dataInprogress || {};

  const { currentURL = {}, thumbnailsProps, product } = allParentProps || {};

  const { userCurrency, userdata } = dataAuth || {};
  const { ratio, currency } = userCurrency || {};
  const { balance, balance_with_fee, locked_balance, country_code = "" } = userdata || {};
  const { variant_payment_methods = [] } = dataProductDetails || {};
  const productImage = (() => {
    return thumbnailsProps
      ? Array.isArray(thumbnailsProps)
        ? thumbnailsProps.length > 0
          ? thumbnailsProps[0].URL
          : ""
        : ""
      : "";
  })();

  const {
    id: initShippingId = "",
    alias: initAlias,
    full_name: initFullName,
    street_address: initStreetAddress,
    city: initCity,
    province: initProvince,
    postal_code: initPostalCode,
    country: initCountry,
  } = shippingHistory.data ? shippingHistory.data.length > 0 ? shippingHistory.data[0] : {} : {};

  const { display_name = "" } = sell.product_variant || {};

  const {
    isSubmit
  } = dataOffer.submitOffer || {}

  /* USE STATE */
  // SHIPPING STATE
  const [isOtpActive, setIsOtpActive] = useState(false)

  const { saveToLocalStorage, checkIfExpired, resendOtp, resetOtpFromLocalstorage } = useOtpStorage()
  const [isAddressBookOpen, setIsAddressBookOpen] = useState(false);
  const [makeOfferProcess, setMakeOfferProcess] = useState("");
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [_paymentMethods, setPaymentMethods] = useState(DEFAULT_PAYMENT_METHOD);
  const [shippingId, setShippingId] = useState(initShippingId || 0);
  const [_shippingFee, set_ShippingFee] = useState(0)
  const [fetchShippingFee, setFetchShippingFee] = useState(true);
  const [_discount, set_Discount] = useState(0);
  const [defaultId, setDefaultId] = useState(initShippingId || 0);
  const [amountToBePaid, setAmountToBePaid] = useState(0);
  const [error, setError] = useState("");
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [isBcaOnly, setIsBcaOnly] = useState(false);
  const [_installmentsList, set_InstallmentsList] = useState([]);
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState(null);
  const [isOpenInsuficientBalance, setIsOpenInsuficientBalance] = useState(false);
  const [atomePrice, setAtomePrice] = useState(0);
  const [isOpenModalBalanceInfo, setIsModalBalanceInfo] = useState(false);
  const [isKickCreditActive, setIsKickCreditActive] = useState(false);
  const [isKickPointActive, setIsKickPointActive] = useState(false);
  const [adminFee, setAdminFee] = useState(0)
  const [_paymentType, set_PaymentType] = useState()
  const [_isErrorShippingFetch, set_IsErrorShippingFetch] = useState(false);
  const [errMessages, setErrMessages] = useState([]);
  const [popUpErrorMessage, setPopUpErrorMessage] = useState("")
  const [_errorAddress, set_ErrorAddress] = useState("");
  const [_error, set_Error] = useState(null)
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  const [_messageField, set_MessageField] = useState(null)
  const [totalBalance, setTotalBalance] = useState(
    parseInt(balance) + parseInt(balance_with_fee) + parseInt(locked_balance)
  );
  const [defaultAddressTemp, setDefaultTempAddress] = useState(null)
  const [showModalOtp, setShowModalOtp] = useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [currentProcess, setCurrentProcess] = useState("");
  const [gettingOtp, setGettingOtp] = useState(false);

  const [_sell, set_Sell] = useState({
    ...sell,
    asking_price: parseFloat(sell.asking_price),
    subsidy_price: sell.subsidy_price ? parseInt(sell.subsidy_price) : 0,
  });
  const summaryRef = useRef()
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState({
    id: initShippingId,
    alias: initAlias,
    full_name: initFullName,
    street_address: initStreetAddress,
    city: initCity,
    province: initProvince,
    postal_code: initPostalCode,
    country: initCountry,
  });
  const [balanceUsage, setBalanceUsage] = useState({
    sellerCredit: 0,
    kickCredit: 0,
    kickPoint: 0,
    remainingPayment: 0,
  });
  const [width, setWidth] = useState(0);
  const [isSplitPayment, setIsSplitPayment] = useState(false);


  /* FUNCTIONS */
  const backToDetailsPage = () => {
    props.history.push(`${currentURL.url}`);
  };

  const handleModalAddressToggle = () => {
    setIsAddressBookOpen(!isAddressBookOpen);
  };

  const changeId = (id = "") => {
    setIsAddressButtonDisable(true);
    setShippingId(id);
  };

  const _handleSelectedAddress = (item) => {
    getProvinces(item.country);
    getCountries();
    getCities(item.country, item.province);
    setSelectedAddress(item);
    setIsAddressButtonDisable(false);
    setError("");
  };

  const submitShipping = () => {
    setDefaultId(shippingId);
    const temp = shippingHistory.data.filter(
      (item) => item.id === shippingId
    )[0];
    _handleSelectedAddress(temp || selectedAddress);
    setSelectedShipping(!temp ? selectedAddress.alias : temp.alias);
    setFetchShippingFee(true)
    setShippingId(!temp ? selectedAddress.id : temp.id);
    setIsAddressBookOpen(!isAddressBookOpen);
  };

  const handleSetAtomePrice = () => {
    const { asking_price = 0, total_subsidy = 0 } = _sell || {};
    const price = total_subsidy
      ? parseInt(total_subsidy)
      : parseInt(asking_price);
    setAtomePrice(Math.ceil(price / 3));
  };

  const fetchKredivoInstallments = () => {
    const { kredivoAvailableInstallment } = dataPayments;
    if (kredivoAvailableInstallment.status_code === 200) {
      if (kredivoAvailableInstallment.user_sell_id === _sell.id) {
        const list = kredivoAvailableInstallment.data.installments.map(
          (item) => {
            return {
              value: item.id,
              label: item.name,
              monthly_installment: item.monthly_installment,
            };
          }
        );
        set_InstallmentsList(list);
      }
    } else {
      // Fetch now...
      // Or not show, because have been loaded from product detail page.
    }
  };

  const handleUsageBalance = (walletType, isActive) => {
    // Parse all balance to type integer
    let kickCreditBalance = parseInt(balance);
    let balanceWithFee = parseInt(balance_with_fee);
    let lockedBalance = parseInt(locked_balance);

    const {
      kickCredit,
      kickPoint,
      sellerCredit,
      remainingPayment
    } = balanceUsage

    // Define remaining payment
    let currentRemainingPayment = remainingPayment;

    let temporaryKickPoint = 0

    if (walletType === "kick_points") {
      if (isActive) {
        // HANDLE JIKA REMAINING PAYMENT 0 POINTS TIDAK BISA DI PAKAI
        if (remainingPayment === 0) return
        // Calculate how much of kickpoint used IF ONLY kick points active
        let selisihKickPointsWithTobePaid =
          lockedBalance - currentRemainingPayment;

        temporaryKickPoint =
          selisihKickPointsWithTobePaid <= 0
            ? lockedBalance
            : lockedBalance - selisihKickPointsWithTobePaid;
        currentRemainingPayment =
          selisihKickPointsWithTobePaid <= 0
            ? Math.abs(selisihKickPointsWithTobePaid)
            : 0;

        setBalanceUsage({
          ...balanceUsage,
          kickPoint: temporaryKickPoint,
          remainingPayment: currentRemainingPayment,
        });
      } else {
        const totalBalance = kickCredit + sellerCredit
        const remain = amountToBePaid - currentRemainingPayment - totalBalance
        setBalanceUsage({
          ...balanceUsage,
          kickPoint: 0,
          remainingPayment: currentRemainingPayment + remain,
        });
      }
    } else if (walletType === "kick_credits") {
      if (isActive) {
        // HANDLE JIKA REMAINING PAYMENT 0 CREDIT TIDAK BISA DI PAKAI
        if (remainingPayment === 0) return

        // 1. Calculate usage of sellerCredit first
        let selisihSellerCreditWithTobePaid =
          balanceWithFee - currentRemainingPayment;

        let sellerCredit =
          selisihSellerCreditWithTobePaid <= 0
            ? balanceWithFee
            : balanceWithFee - selisihSellerCreditWithTobePaid;
        currentRemainingPayment =
          selisihSellerCreditWithTobePaid <= 0
            ? Math.abs(selisihSellerCreditWithTobePaid)
            : 0;

        // 2. Second calculate how much of kickCredit used
        let selisihKickCreditWithTobePaid =
          kickCreditBalance - currentRemainingPayment;

        let kickCredit =
          selisihKickCreditWithTobePaid <= 0
            ? kickCreditBalance
            : kickCreditBalance - selisihKickCreditWithTobePaid;
        currentRemainingPayment =
          selisihKickCreditWithTobePaid <= 0
            ? Math.abs(selisihKickCreditWithTobePaid)
            : 0;

        setBalanceUsage({
          ...balanceUsage,
          sellerCredit,
          kickCredit,
          remainingPayment: currentRemainingPayment,
        });
      } else {
        const remain = amountToBePaid - currentRemainingPayment - kickPoint
        setBalanceUsage({
          ...balanceUsage,
          sellerCredit: 0,
          kickCredit: 0,
          remainingPayment: currentRemainingPayment + remain,
        });
      }
    } else {
      setBalanceUsage({
        ...balanceUsage,
        remainingPayment: parseInt(amountToBePaid),
      });
    }

  };

  const handleAvailablePaymentMethods = () => {
    const setPayment = [];

    if (variant_payment_methods.length > 0) {
      const dataPayments = _paymentMethods.map(payments => {
        var variantPaymentMethod = Object.assign({}, payments);
        variant_payment_methods.find(item => {
          const isSetPayment = setPayment.includes(item.payment_method) ? setPayment : setPayment.push(item.payment_method);
          if (!setPayment.includes(payments.payment_method))
            variantPaymentMethod.active = false;
          else
            variantPaymentMethod.active = true;
        })
        return variantPaymentMethod;
      });

      const paymentType = setPayment.length && setPayment.includes(BCA_VA) ? BCA_VA :
        setPayment.length && setPayment.includes(BANKTRANSFER) ? BANKTRANSFER :
          setPayment.length && (setPayment.includes(KREDIVO) || setPayment.includes(AKULAKU)) ? DEFAULT_CREDIT_CARD :
            (setPayment.length ? setPayment[0] : null);

      setPaymentMethods(dataPayments)
      set_PaymentType(paymentType)
    }
  }

  const _getAdmFee = () => {
    const admFee = getAdmFees(
      _paymentType,
      parseFloat(inputOffer / ratio),
      parseFloat(_shippingFee),
      _discount
    );

    setAdminFee(admFee)
  }

  const _calculateShippingFee = async (provinceId, country = "IDN") => {
    const { id, weight } = product || {};

    let payloads = {
      country,
      destination: provinceId,
      product_variant_id: id,
      weight: weight || 1000,
      courier: "FLAT_RATE",
      country,
      product_price: parseInt(inputOffer),
    };
    setFetchShippingFee(true)
    await set_IsErrorShippingFetch(false);
    await getShippingFee(payloads).then(() => setFetchShippingFee(false))
  };

  const _bidAmountRules = () => {
    const bidAmount = inputOffer;

    const messages = {
      error: [],
      success: []
    };

    const {
      asking_price,
      highest_bid,
      subsidy_price: _subsidy_price
    } = _sell || {};

    let subsidy_price = _subsidy_price;
    const limitOffer = parseInt(asking_price) - 50000;
    const { amount } = highest_bid == null ? 0 : highest_bid;
    const buyNow = <ButtonBuy>buy now!</ButtonBuy>;
    subsidy_price = subsidy_price ? subsidy_price : 0

    //bid amount
    if (bidAmount === "") {
      messages.error.push("Please fill in the amount of your Offer.");
    } else if (!isNumeric(bidAmount)) {
      messages.error.push("This field must be numeric.");
    } else if (bidAmount / ratio == (parseFloat(asking_price) - parseInt(subsidy_price))) {
      messages.error.push(
        <span className="text-left text-danger">
          Cannot make an offer with the same price {currency}{" "}
          {convertToRupiah(parseFloat(asking_price * ratio) - parseInt(subsidy_price))}. You should {buyNow}
        </span>
      );
    } else if (bidAmount / ratio > (parseFloat(asking_price) - parseInt(subsidy_price))) {
      messages.error.push(
        <span className="text-left text-danger">
          Cannot make an offer greater than {currency}{" "}
          {convertToRupiah(parseFloat((asking_price - parseInt(subsidy_price)) * ratio))}. You should {buyNow}
        </span>
      );
    }

    if (messages.error.length === 0) {
      if (bidAmount / ratio > parseFloat(amount)) {
        messages.success.push(`You have the highest offer.`);
      }
    }
    return messages;
  }

  const _validateBidAmountInput = () => {
    const { error, success } = _bidAmountRules();
    const errors = error.reduce((err, item) => {
      err["bidAmount"] = err["bidAmount"]
        ? [...err["bidAmount"], item]
        : [item];
      return { ...err };
    }, {});
    const _messageField = success.length
      ? {
        bidAmount: [success[0]]
      }
      : null;
    const errorData = Object.keys(errors).length
      ? {
        errors: { ...errors },
        status_code: 422,
        message: "Please check your form and try again."
      }
      : null;

    set_Error(errorData)
    set_MessageField(_messageField)

    return _error === null;
  }
  const _validateForm = (shippingPayload = {}, contryList) => {
    let errors = {};
    const {
      alias: _alias,
      full_name: _fullName,
      phone_number: _phoneNumber,
      street_address: _alamat,
      country: _countrySelected,
      province: _province,
      city: _citySelected,
      postal_code: _postalCode
    } = shippingPayload

    const _phoneCode = _phoneNumber ? _phoneNumber.slice(0, 3).split("+")[1] : ""
    const codeArea = contryList.phone_code

    const _phone = _phoneCode === codeArea ? codeArea : null

    if (
      _alias === "" ||
      _alias === undefined ||
      _alias === null
    )
      errors["_alias"] = ["Please insert alias."];
    if (
      _fullName === "" ||
      _fullName === undefined ||
      _fullName === null
    )
      errors["_fullName"] = ["Please insert recipient name."];
    if (
      _phone === "" ||
      _phone === undefined ||
      _phone === null
    )
      errors["_phone"] = ["Please insert area code ."];
    if (
      _phoneNumber === "" ||
      _phoneNumber === undefined ||
      _phoneNumber === null
    )
      errors["_phoneNumber"] = ["Please insert phone number."];
    else if (!isNumeric(_phoneNumber))
      errors["_phoneNumber"] = ["Phone number must be numeric"];
    if (
      _alamat === "" ||
      _alamat === undefined ||
      _alamat === null
    )
      errors["_alamat"] = ["Please insert address."];
    if (
      _countrySelected === "" ||
      _countrySelected === undefined ||
      _countrySelected === null
    )
      errors["_country"] = ["Please choose country."];
    if (
      _province === "" ||
      _province === undefined ||
      _province === null ||
      _province == -1
    )
      errors["_province"] = ["Please choose province."];
    if (
      _citySelected === "" ||
      _citySelected === undefined ||
      _citySelected === null
    )
      errors["_city"] = ["Please choose city."];
    if (
      _postalCode === "" ||
      _postalCode === undefined ||
      _postalCode === null ||
      _postalCode == -1
    )
      errors["_postalCode"] = ["Please insert postal code."];
    else if (!isNumeric(_postalCode))
      errors["_postalCode"] = ["Postal code must be numeric."];

    if (Object.keys(errors).length) {
      set_Error({
        _error: {
          errors: { ...errors },
          errorShipping: true,
          status_code: 422,
          message: "Harap isi semua column berbintang"
        }
      });
    }

    return errors;
  }

  const handleChoosePayment = () => {
    const { cost, error = null, status_code } = couriers || {};
    if (error) {
      if (error.status_code >= 500) {
        setPopUpErrorMessage("Sorry, we have a problem!. Please inform our friendly staff via Whatsapp +6281210005425")
      } else {
        setPopUpErrorMessage(printError(error))
      }
      setIsErrorModalOpen(true)
    } else {
      !fetchShippingFee && setMakeOfferProcess("choose-payment")
    }
  }

  const getOtpHandler = () => {
    if (checkIfExpired()) {
      getOtp()
    } else {
      setOtpErrorMsg("")
      setGettingOtp(false)
      setShowModalOtp(true)
    }
  }

  const handleSubmit = (otpCode) => {
    setIsLoadingSubmit(true)
    // SHIPPING FEE PAYLOAD
    const completeSelectedAddressInfo =
      shippingHistory.data &&
      shippingHistory.data.length > 0 &&
      shippingHistory.data.filter((postal) => selectedAddress.id === postal.id);
    const phoneNumber =
      countries.data &&
      countries.data.length > 0 &&
      countries.data.filter(
        (country) => country.code3 === selectedAddress.country
      );
    const provinceId =
      provinces.data &&
      provinces.data.length > 0 &&
      provinces.data.filter(
        (province) => province.name === selectedAddress.province
      );
    const cityId =
      cities.data &&
      cities.data.length > 0 &&
      cities.data.filter((city) => city.name === selectedAddress.city);

    const contryList = cityId.length > 0 ? cityId[0].province.country : {}

    const shippingPayload = {
      id: completeSelectedAddressInfo[0].id,
      alias: completeSelectedAddressInfo[0].alias,
      full_name: completeSelectedAddressInfo[0].full_name,
      phone_number: completeSelectedAddressInfo[0].phone_number,
      street_address: completeSelectedAddressInfo[0].street_address,
      note: completeSelectedAddressInfo[0].note,
      country: completeSelectedAddressInfo[0].country,
      province: completeSelectedAddressInfo[0].province,
      province_id: provinceId.length > 0 && provinceId[0].id,
      city: completeSelectedAddressInfo[0].city,
      city_id: cityId.length > 0 ? cityId[0].id : null,
      postal_code: completeSelectedAddressInfo[0].postal_code,
    };

    const isCreditUse = currentPaymentMethod.payment_method === FULLWALLET ? true : false
    const isUseKickPoints = isKickPointActive

    const isValidBidAmount = _validateBidAmountInput();

    const valid = _validateForm(shippingPayload, contryList);
    const { product_variant_id, size = {}, id: user_sell_id } = _sell || {};
    const payload = {
      shipping_id: shippingPayload.id,
      shipping: shippingPayload,
      product_variant_id,
      size_id: size.id,
      payment_method: currentPaymentMethod.payment_method,
      amount: inputOffer / ratio,
      ka_courier_price: _shippingFee,
      administration_fee: adminFee,
      user_sell_id,
      point_enabled: isUseKickPoints
    };

    if (otpCode) {
      payload.otp = otpCode
    }

    if (collection_id) {
      payload.collection_id = collection_id
    }

    const shippingCountry = selectedAddress?.country || 'IDN'

    if (currentPaymentMethod.payment_method === 'credit_card' || currentPaymentMethod.payment_method === BCA_CREDIT_CARD) {
      if (currentPaymentMethod.label === 'BCA Card' || currentPaymentMethod.payment_method === BCA_CREDIT_CARD) {
        payload.payment_via = 'spa'
      } else if (shippingCountry !== 'IDN') {
        payload.payment_via = 'xnd'
      } else {
        payload.payment_via = 'vt'
      }
    }

    const { dataOfferPending } = offerPending || {}
    const dataUpdate = dataOfferPending.length > 0 ? dataOfferPending.find(bid => bid.size_id === _sell.size_id) : undefined

    !dataUpdate ? doPostUserOffer(payload) : updateOffer(dataUpdate.id, payload)
  }


  // COMPONENT DID MOUNT
  useEffect(() => {
    (!dataInprogress || !isFromDetail || !currentURL) &&
      props.history.push("/");
    setWidth(window.innerWidth);
    getHistoryShipping();
    fetchKredivoInstallments();
    handleAvailablePaymentMethods();
    _getAdmFee();
    resetPostUserOffer();
    getOtpStatus();
  }, []);

  useEffect(() => {
    if (otpStatus?.data?.pay_with_wallet) {
      setIsOtpActive(otpStatus.data.pay_with_wallet)
    } else {
      setIsOtpActive(false)
    }
  }, [otpStatus?.data?.pay_with_wallet])

  // GET CITIES, COUNTRIES, PROVINCES
  useEffect(() => {
    const {
      id: initShippingId,
      alias: initAlias,
      full_name: initFullName,
      street_address: initStreetAddress,
      city: initCity,
      province: initProvince,
      postal_code: initPostalCode,
      country: initCountry,
    } = shippingHistory.data ? shippingHistory.data.length > 0 ? shippingHistory.data[0] : {} : {};

    setSelectedAddress({
      id: initShippingId,
      alias: initAlias,
      full_name: initFullName,
      street_address: initStreetAddress,
      city: initCity,
      province: initProvince,
      postal_code: initPostalCode,
      country: initCountry,
    });

    getCountries();
    getProvinces(initCountry);
    getCities(initCountry, initProvince);
  }, [shippingHistory.data]);

  // GET AMOUNT TO BE PAID / TOTAL PAYMENT
  useEffect(() => {
    setAmountToBePaid(parseInt(_shippingFee + adminFee + parseInt(inputOffer)))
  }, [_shippingFee, adminFee, inputOffer])

  // CALCULATE SHIPPING FEE => CHECK THIS USEEFFECT => DETECT AND SET SHIPPING FEE
  useEffect(() => {
    (async () => {
      const { data = [] } = provinces || {};
      const { province = "", country = "", city = "" } = selectedAddress || "";

      let provinceId = null;
      let cityId = null;
      await getProvinces(country).then(({ value }) => {
        const { data = [] } = value || {};
        if (data.length === 0 || !province) return;

        const currentProvinceId = data.filter(
          (datum) => datum.name === province
        );
        provinceId =
          Array.isArray(currentProvinceId) && currentProvinceId.length > 0
            ? currentProvinceId[0].id
            : null;
      });

      await _calculateShippingFee(provinceId, country)
    })();
  }, [selectedAddress])

  // DETECT AND SET SHIPPING FEE
  useEffect(() => {
    const { cost, error = {} } = couriers || {};
    const { destination = [] } = (error && error.errors) || {};
    if (destination.length > 0) {
      setErrMessages([...destination, ...errMessages]);
      return;
    }
    set_ShippingFee(cost);
  }, [couriers]);

  // COUNT USAGE OF SELLER CREDIT, KICK CREDIT ON SPLIT PAYMENT SUMMARY
  useEffect(() => {
    amountToBePaid > 1 && handleUsageBalance();
  }, [amountToBePaid]);

  // AFTER SUBMIT OFFER
  useEffect(() => {
    const { error = null, data = null } = dataOffer.submitOffer || {};

    if (error) {
      setIsLoadingSubmit(false)
      const { errors, status_code } = error || {}

      if (status_code === 422) {
        const uiKeys = {
          amount: "bidAmount"
        };
        let _errors = {};
        Object.keys(errors).forEach(key => {
          let msg = errors[key][0];
          if (typeof errors[key][0] === "object")
            msg = errors[key][0].message;
          const getUiKey = Object.keys(uiKeys).find(uiKey => uiKey === key);
          if (getUiKey) _errors[uiKeys[getUiKey]] = [msg];
          else _errors[key] = [msg];
        });
        set_Error({ ...error, errors: { ..._errors } })
        set_ErrorAddress("Please input a shipping address!")
        setPopUpErrorMessage("Please input a shipping address!")
      }

      if (status_code === 400) {
        setPopUpErrorMessage("Your balance is not enough to enter bid systems!")
      }

      const printErrorMsg = printError(error)
      setPopUpErrorMessage(printErrorMsg === "Invalid OTP" ? "" : printErrorMsg)
      setIsErrorModalOpen(printErrorMsg === "Invalid OTP" ? false : true)
      setOtpErrorMsg(printErrorMsg === "Invalid OTP" ? printErrorMsg : "")

      setGettingOtp(false)
      if (isOtpActive && typeof printErrorMsg === "string" && printErrorMsg.toLocaleLowerCase().includes("otp")) {
        setShowModalOtp(true)
      }

    } else {
      if (!data) return
      const { product_variant = {}, amount, user_id, user = {}, product_variant_id } = data || {}
      const { display_name, product = {}, SKU } = product_variant || {}
      const { category = {} } = product

      resetOtpState()
      setShowModalOtp(false)
      resetOtpFromLocalstorage()
      setTimeout(() => {
        setIsLoadingSubmit(false)
        Analytics.recordOffer(
          display_name,
          category.name,
          SKU,
          "product",
          amount,
          "IDR",
          user_id,
          user.username,
          _sell.id,
          product_variant_id
        );
        resetPostUserOffer();
        history.push({
          pathname: `${currentURL.url}/offer/live`,
          state: { ...data, sell: _sell, currentURL: currentURL.url }
        });
      }, 3000)
    }
  }, [dataOffer.submitOffer])

  // DETECT ANY ERROR OCCURED
  useEffect(() => {
    if (isErrorModalOpen) {
      setTimeout(() => {
        setIsErrorModalOpen(false);
      }, 3000);
    }
  }, [isErrorModalOpen]);

  /* USE EFFECTS */
  useLayoutEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateSize);
  });

  useEffect(() => {
    const { error = null, data = null, status_code } = dataOffer.updatedOffer || {};
    if (!status_code) return
    if (error) {
      setIsLoadingSubmit(false)
      const printErrorMsg = printError(error)
      setPopUpErrorMessage(printErrorMsg === "Invalid OTP" ? "" : printErrorMsg)
      setIsErrorModalOpen(printErrorMsg === "Invalid OTP" ? false : true)
      setOtpErrorMsg(printErrorMsg === "Invalid OTP" ? printErrorMsg : "")

      setGettingOtp(false)

      if (isOtpActive && typeof printErrorMsg === "string" && printErrorMsg.toLocaleLowerCase().includes("otp")) {
        setShowModalOtp(true)
      }
    } else {
      if (!data) return
      const { product_variant = {}, user_id, user = {}, product_variant_id, size } = data || {}
      const { display_name, product = {}, SKU } = product_variant || {}
      const { category = {} } = product

      const amount = inputOffer

      if (status_code !== 200) return
      resetOtpFromLocalstorage()
      setTimeout(() => {
        history.push({
          pathname: `${currentURL.url}/offer/live`,
          state: { ...data, sell: _sell, currentURL: currentURL.url, isUpdateOffer: true, amount, updateProductImage: productImage }
        });
        setIsLoadingSubmit(false)
      }, 3000)

    }
  }, [dataOffer.updatedOffer])

  useEffect(() => {
    if (otpCode.success) {
      setOtpErrorMsg("")
      setGettingOtp(false)
      setShowModalOtp(true)
      saveToLocalStorage()
    } else if (otpCode?.message) {
      setOtpErrorMsg(otpCode?.message)
      setGettingOtp(false)
      setShowModalOtp(true)
    } else {
      setOtpErrorMsg("")
    }
  }, [otpCode])

  const isIndonesian = userdata.country_code === "IDN";
  return <>
    {showModalOtp ? <ModalOtp
      show={showModalOtp}
      onHide={() => {
        setShowModalOtp(!showModalOtp)
        resetOtpState()
      }}
      email={userData?.email ?? ""}
      submitOtp={(otpCode) => {
        setShowModalOtp(false)
        handleSubmit(otpCode)
      }}
      resendCode={() => {
        // getOtpHandler()
        getOtp()
        setGettingOtp(true)
        resendOtp()
      }}
      gettingOtp={gettingOtp}
      errorMsg={otpErrorMsg}
      currentProcess={currentProcess}
      backAction={() => {
        setShowModalOtp(false)
        resetOtpState()
      }}
    /> : null}

    {(width >= 1024) ? (
      <div id="make-offer-page-container">
        <LoadingSubmit show={isLoadingSubmit} />
        <PopUpErrorMessage isErrorModalOpen={isErrorModalOpen} errMessages={popUpErrorMessage} />
        <div className="make-offer-inner-container">
          <div className="make-offer-left-content">
            <div className="title-wrapper">
              <h3>Checkout Make Offer</h3>
            </div>
            <div className="content-wrapper">
              <div className="image-wrapper">
                {productImage ? (
                  <KickImage src={getCloudImageUrl(productImage, 500)} alt="..." />
                ) : (
                  <KickImage src={emptyImage(category || "sneakers")} alt="..." />
                )}
              </div>
              <p>{display_name}</p>
              <p>
                {size.US} / {productCondition} / {etaText}{" "}
              </p>
              <p>IDR {convertToRupiah(parseInt(inputOffer))}</p>
            </div>
            <div className="description-wrapper">
              <p>
                Should your offer gets accepted, you have authorized us to
                complete the transaction and change your card with the amount
                according to the offer (not including shipping and handling fee).
                Any false information given can lead to account suspension,
                therefore we encourage every user to carefully review their
                activities on our platform.
              </p>
            </div>
          </div>
          <div className="make-offer-right-content">
            {
              makeOfferProcess === "" &&
              <>
                <div className="shipping-address-wrapper"
                  onClick={() => handleModalAddressToggle()}
                >
                  <div className="pin-icon-wrapper">
                    <KickImage src={PinAddress} alt="..." />
                  </div>
                  <div className="address-wrapper">
                    <p>Deliver to</p>
                    <div className="address-details-wrappers">
                      <p>
                        {selectedAddress.alias} - {selectedAddress.full_name}
                      </p>
                      <p>
                        {selectedAddress.street_address}, {selectedAddress.city},{" "}
                        {selectedAddress.province}, {selectedAddress.postal_code}
                      </p>
                    </div>
                  </div>
                  <div className="select-others-address-wrapper"></div>
                  {isAddressBookOpen && (
                    <ModalAddressBookV3
                      isOpen={isAddressBookOpen}
                      onToggle={() => handleModalAddressToggle()}
                      dataAddress={shippingHistory.data || []}
                      countries={countries.data || []}
                      provinces={provinces.data || []}
                      cities={cities.data || []}
                      id={shippingId ? shippingId : selectedAddress.id}
                      changeId={changeId}
                      defaultId={defaultId}
                      submitShipping={submitShipping}
                      getHistoryShipping={getHistoryShipping}
                      handleSelectedAddress={_handleSelectedAddress}
                      isModalOffer={true}
                      isAddressButtonDisable={isAddressButtonDisable}
                      setDefaultTempAddress={setDefaultTempAddress}
                      defaultAddressTemp={defaultAddressTemp}
                    />
                  )}
                </div>
                <div className="summary-wrapper">
                  <div className="summary-details-wrapper">
                    <div>
                      <p>Payment Summary</p>
                    </div>
                    <div>
                      <p>Offer Price</p>
                      <p>IDR. {convertToRupiah(parseInt(inputOffer))}</p>
                    </div>
                    <div>
                      <p>Administration Fee</p>
                      <p>IDR. {convertToRupiah(adminFee)}</p>
                    </div>
                    <div>
                      <p>Shipping {`&`} Handling</p>
                      <p>IDR. {convertToRupiah(_shippingFee)}</p>
                    </div>
                    <div>
                      <p>Total</p>
                      <p>IDR. {convertToRupiah(amountToBePaid)}</p>
                    </div>
                  </div>
                  <div className="btn-wrapper">
                    <div onClick={() => backToDetailsPage()}>
                      <KickImage src={BackArrow} alt="back" />
                      <p>Back</p>
                    </div>
                    <div
                      onClick={() => handleChoosePayment()}
                    >
                      <p>Choose Payment</p>
                      <KickImage src={ContinueArrow} alt="back" />
                    </div>
                  </div>
                </div>
              </>
            }
            {
              makeOfferProcess === "choose-payment" &&
              <ChoosePaymentProcess
                balance={balance}
                totalBalance={totalBalance}
                balance_with_fee={balance_with_fee}
                locked_balance={locked_balance}
                dataAkulaku={dataAkulaku}
                isIndonesian={isIndonesian}
                shippingCountry={selectedAddress?.country || 'IDN'}
                amountToBePaid={amountToBePaid}
                _paymentMethods={_paymentMethods}
                _installmentsList={_installmentsList}
                setMakeOfferProcess={setMakeOfferProcess}
                handleSetAtomePrice={handleSetAtomePrice}
                setCurrentPaymentMethod={setCurrentPaymentMethod}
                setIsOpenInsuficientBalance={setIsOpenInsuficientBalance}
                setIsSplitPayment={setIsSplitPayment}
                balanceUsage={balanceUsage}
              />
            }
            {
              makeOfferProcess === "confirm-kick-credit" &&
              <KickCreditProcess
                balance={balance}
                dataAkulaku={dataAkulaku}
                isIndonesian={isIndonesian}
                balanceUsage={balanceUsage}
                totalBalance={totalBalance}
                amountToBePaid={amountToBePaid}
                isSplitPayment={isSplitPayment}
                locked_balance={locked_balance}
                balance_with_fee={balance_with_fee}
                _installmentsList={_installmentsList}
                isKickPointActive={isKickPointActive}
                currentPaymentMethod={currentPaymentMethod}
                isOpenModalBalanceInfo={isOpenModalBalanceInfo}
                handleSubmit={() => {
                  if (isOtpActive) {
                    getOtpHandler()
                  } else {
                    handleSubmit()
                  }
                }}
                setMakeOfferProcess={setMakeOfferProcess}
                handleUsageBalance={handleUsageBalance}
                setIsKickPointActive={setIsKickPointActive}
                setIsModalBalanceInfo={setIsModalBalanceInfo}
                isOpenInsuficientBalance={isOpenInsuficientBalance}
                setCurrentPaymentMethod={setCurrentPaymentMethod}
                isOpenModalBalanceInfo={isOpenModalBalanceInfo}
                setIsOpenInsuficientBalance={setIsOpenInsuficientBalance}
                isSubmit={isSubmit}
                isKickCreditActive={isKickCreditActive}
                setIsKickCreditActive={setIsKickCreditActive}
              />
            }
            {/* Virtual Account, Credit Card, Bank Transfer, AkuLaku */}
            {makeOfferProcess === "confirm-others-kick-credit" && (
              <OtherPaymentsConfirmationProcess
                amountToBePaid={convertToRupiah(amountToBePaid)}
                currentPaymentMethod={currentPaymentMethod}
                handleSubmit={handleSubmit}
                setMakeOfferProcess={setMakeOfferProcess}
                setCurrentPaymentMethod={setCurrentPaymentMethod}
                isSubmit={isSubmit}
              />
            )}
          </div>
        </div>
      </div>
    ) : (
      <div id="make-offer-page-container-responsive-view">
        <PopUpErrorMessage isErrorModalOpen={isErrorModalOpen} errMessages={popUpErrorMessage} />
        <LoadingSubmit show={isLoadingSubmit} />
        {
          makeOfferProcess === "" && <div className="responsive-makeoffer-wrapper">
            {/* BACK BUTTON */}
            <div className="responsive-top-bag-title">
              <KickImage src={CircleBack} alt="..."
                onClick={() => backToDetailsPage()}
              />
              <p>Checkout (Make Offer)</p>
            </div>

            {/* ADDRESS SECTION */}
            <div className="address-section-wrapper">
              <div className="address-section-container"
                onClick={() => handleModalAddressToggle()}
              >
                <div className="image-container">
                  <KickImage src={PinAddress} alt="..." />
                </div>
                <div className="description-container">
                  <p>Deliver to</p>
                  {selectedAddress ? (
                    <>
                      <p>
                        {selectedAddress.alias} - {selectedAddress.full_name}
                      </p>
                      <p>
                        {selectedAddress.street_address}, {selectedAddress.city},{" "}
                        {selectedAddress.province}, {selectedAddress.postal_code}
                      </p>
                    </>
                  ) : null}
                </div>
              </div>
              {isAddressBookOpen && (
                <ModalAddressBookV3
                  isOpen={isAddressBookOpen}
                  onToggle={() => handleModalAddressToggle()}
                  dataAddress={shippingHistory.data || []}
                  countries={countries.data || []}
                  provinces={provinces.data || []}
                  cities={cities.data || []}
                  id={shippingId ? shippingId : selectedAddress.id}
                  changeId={changeId}
                  defaultId={defaultId}
                  submitShipping={submitShipping}
                  getHistoryShipping={getHistoryShipping}
                  handleSelectedAddress={_handleSelectedAddress}
                  isModalOffer={true}
                  isAddressButtonDisable={isAddressButtonDisable}
                  setDefaultTempAddress={setDefaultTempAddress}
                  defaultAddressTemp={defaultAddressTemp}
                />
              )}
            </div>

            {/* PRODUCT CARD + ADDON SELECTED */}
            <div className="product-card-container">
              <div className="product-card-wrapper">
                <div className="image-wrapper">
                  {productImage ? (
                    <KickImage src={getCloudImageUrl(productImage, 500)} alt="..." />
                  ) : (
                    <KickImage src={emptyImage(category || "sneakers")} alt="..." />
                  )}
                </div>
                <div className="description-wrapper">
                  <div className="name-and-condition">
                    <p>{display_name}</p>
                    <p>
                      {size.US} / {productCondition} / {etaText}{" "}
                    </p>
                  </div>
                  <p className="input-price">IDR {convertToRupiah(parseInt(inputOffer))}</p>
                </div>
              </div>
            </div>

            {/* PAYMENT SUMMARY */}
            <div ref={summaryRef} className="summary-wrapper">
              <div className="summary-details-wrapper">
                <div className="summary-row">
                  <p>Payment Summary</p>
                </div>
                <div className="summary-row">
                  <p>Offer Price</p>
                  <p>IDR. {convertToRupiah(parseInt(inputOffer))}</p>
                </div>
                <div className="summary-row">
                  <p>Administration Fee</p>
                  <p>IDR. {convertToRupiah(adminFee)}</p>
                </div>
                <div className="summary-row">
                  <p>Shipping {`&`} Handling</p>
                  <p>IDR. {convertToRupiah(_shippingFee)}</p>
                </div>
              </div>
            </div>

            <div className="info-make-offer">
              <p>Should your offer gets accepted, you have authorized us to complete the transaction and charge your card with the amount according to the offer (not including shipping and handling fee). Any false information given can lead to account suspension, therefore we encourage every user to carefully review their activities on our platform</p>
            </div>

            {/* BTN Wrapper */}
            {!isAddressBookOpen && <div className="floating-btn-wrapper">
              <div onClick={() => summaryRef.current.scrollIntoView({ behavior: "smooth" })} className="total-price">
                <p>Total</p>
                <p>IDR. {convertToRupiah(amountToBePaid)}</p>
              </div>
              <div
                className="continue-button"
                onClick={() => handleChoosePayment()}
              >
                <p>Choose Payment</p>
                <KickImage src={ContinueArrow} alt="back" />
              </div>
            </div>}
          </div>
        }
        {
          makeOfferProcess === "choose-payment" &&
          <ChoosePaymentProcessResponsive
            balance={balance}
            totalBalance={totalBalance}
            balance_with_fee={balance_with_fee}
            locked_balance={locked_balance}
            dataAkulaku={dataAkulaku}
            isIndonesian={isIndonesian}
            shippingCountry={selectedAddress?.country || 'IDN'}
            amountToBePaid={amountToBePaid}
            _paymentMethods={_paymentMethods}
            _installmentsList={_installmentsList}
            setMakeOfferProcess={setMakeOfferProcess}
            handleSetAtomePrice={handleSetAtomePrice}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            setIsOpenInsuficientBalance={setIsOpenInsuficientBalance}
            productImage={productImage}
            emptyImage={emptyImage(category || "sneakers")}
            display_name={display_name}
            productCondition={productCondition}
            inputOffer={inputOffer}
            isSplitPayment={isSplitPayment}
            adminFee={adminFee}
            _shippingFee={_shippingFee}
            size={size}
            setIsSplitPayment={setIsSplitPayment}
            balanceUsage={balanceUsage}
          />
        }
        {
          makeOfferProcess === "confirm-kick-credit" &&
          <KickCreditProcess
            balance={balance}
            dataAkulaku={dataAkulaku}
            isIndonesian={isIndonesian}
            balanceUsage={balanceUsage}
            totalBalance={totalBalance}
            amountToBePaid={amountToBePaid}
            locked_balance={locked_balance}
            balance_with_fee={balance_with_fee}
            _installmentsList={_installmentsList}
            isKickPointActive={isKickPointActive}
            currentPaymentMethod={currentPaymentMethod}
            isOpenModalBalanceInfo={isOpenModalBalanceInfo}
            handleSubmit={() => {
              if (isOtpActive) {
                getOtpHandler()
              } else {
                handleSubmit()
              }
            }}
            setMakeOfferProcess={setMakeOfferProcess}
            handleUsageBalance={handleUsageBalance}
            setIsKickPointActive={setIsKickPointActive}
            setIsModalBalanceInfo={setIsModalBalanceInfo}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            isOpenModalBalanceInfo={isOpenModalBalanceInfo}
            isOpenInsuficientBalance={isOpenInsuficientBalance}
            setIsOpenInsuficientBalance={setIsOpenInsuficientBalance}
            isSubmit={isSubmit}
            isKickCreditActive={isKickCreditActive}
            setIsKickCreditActive={setIsKickCreditActive}
            isResponsive={true}
          />
        }
        {/* Virtual Account, Credit Card, Bank Transfer, AkuLaku */}
        {makeOfferProcess === "confirm-others-kick-credit" && (
          <OtherPaymentsConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            currentPaymentMethod={currentPaymentMethod}
            handleSubmit={handleSubmit}
            setMakeOfferProcess={setMakeOfferProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            isSubmit={isSubmit}
          />
        )}
      </div>
    )}
  </>
}

const mapStateToProps = (state) => ({
  dataCountries: state.dataPostalCode.countries,
  dataProvinces: state.dataPostalCode.provinces,
  dataCities: state.dataPostalCode.cities,
  dataCouriers: state.dataPostalCode.couriers,
  dataPostalCode: state.dataPostalCode,
  dataPayments: state.dataPayment,
  dataAuth: state.dataAuth,
  dataCategory: state.dataCategory,
  voucherCode: state.dataPayment.voucherCode,
  currency: state.dataAuth.userCurrency.currency,
  productAddon: state.dataPayment.productAddon,
  dataVoucher: state.dataKickPoint.userVoucher,
  dataAkulaku: state.dataPayment.akulakuAvailableInstallment.data,
  dataOffer: state.dataOffer,
  ratio: state.dataAuth.userCurrency.ratio,
  balance: state.dataAuth.userdata.balance,
  dataProductDetails: state.dataProduct.productDetails,
  offerPending: state.dataOffer.offerPending,
  userData: state.dataAuth.userdata,
  otpStatus: state.dataAuth.otpStatus,
  otpCode: state.dataAuth.otpCode,
});

const mapDispatchToProps = (dispatch) => ({
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: (country) => dispatch(doFetchProvinces(country)),
  getCities: (country = "", province = "") =>
    dispatch(doFetchCities(country, province)),
  getShippingFee: (payload) => dispatch(doPostShippingCost(payload)),
  submitPayment: (payload) => dispatch(doPostPayments(payload)),
  submitXenditPayment: (payload) => dispatch(doPostXenditPayment(payload)),
  submitMidtransPayment: (payload) => dispatch(doPostMidtransPayment(payload)),
  submitKredivoPayment: (payload) => dispatch(doPostKredivoPayment(payload)),
  //TODO: Akulaku
  submitAkulakuPayment: (payload) => dispatch(doPostAkulakuPayment(payload)),
  submitAtomePayment: (payload) => dispatch(doPostAtomePayment(payload)),
  applyVoucher: (payload) => dispatch(doPostApplyVoucher(payload)),
  doGetVoucherCode: (keyword) => dispatch(doGetVoucherCode(keyword)),
  doFetchProductAddon: (payload) => dispatch(doFetchProductAddon(payload)),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  getUserVoucher: () => dispatch(getUserVoucher()),
  doGetKredivoInstallments: (product, amount) =>
    dispatch(doPostKredivoAvailableInstallments(product, amount)),
  submitXenditPayment: (payload) => dispatch(doPostXenditPayment(payload)),
  submitMidtransPayment: (payload) => dispatch(doPostMidtransPayment(payload)),
  submitKredivoPayment: (payload) => dispatch(doPostKredivoPayment(payload)),
  doPostUserOffer: payload => dispatch(doPostUserOffer(payload)),
  resetPostUserOffer: () => dispatch(resetPostUserOffer()),
  updateOffer: (id, payload) => dispatch(updateOffer(id, payload)),
  getOtp: () => dispatch(getOtp()),
  getOtpStatus: () => dispatch(getOtpStatus()),
  resetOtpState: () => dispatch(resetOtpState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MakeOfferPage));
